import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './Content.css';
import PrivateRoute from '../../../Auth/PrivateRoute';
import { Routes as AppRoutes } from '../../../../utils';
import SilentRenew from '../../../Auth/SilentRenew';
import BillsLading from '../../../BillsLading';
import Invoices from '../../../Invoices';
import PurchaseOrders from '../../../PurchaseOrders';
import Reports from '../../../Reports';
import Contact from '../../../Contact';
import Maintenance from '../../../Maintenance';
import OpenOrders from '../../../OpenOrders';
import OpenOrdersDetails from '../../../OpenOrders/OpdenOrdersDetail';
import OpenStatementAcct from '../../../OpenStatementAcct';
import Dashboard from '../../../Dashboard/Dashboard';
import Users from '../../../Users';

export const Content = (): React.JSX.Element => {
  return (
    <Routes>
      <Route
        path={AppRoutes.HOME.route}
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.OPEN_ORDERS.route}
        element={
          <PrivateRoute>
            <OpenOrders />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.ORDERS_DETAILS_BYORDERNO.route}
        element={
          <PrivateRoute>
            <OpenOrdersDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.PURCHASE_ORDERS.route}
        element={
          <PrivateRoute>
            <PurchaseOrders />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.BILLS_LADING.route}
        element={
          <PrivateRoute>
            <BillsLading />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.INVOICES.route}
        element={
          <PrivateRoute>
            <Invoices />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.REPORTS.route}
        element={
          <PrivateRoute>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.OPEN_STATEMENT_ACCT.route}
        element={
          <PrivateRoute>
            <OpenStatementAcct />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.CONTACT.route}
        element={
          <PrivateRoute>
            <Contact />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.SYSTEM_ADMIN_USERS.route}
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRoutes.MAINTENANCE.route}
        element={
          <PrivateRoute>
            <Maintenance />
          </PrivateRoute>
        }
      />
      <Route path={AppRoutes.SILENT_RENEW.route} element={<SilentRenew />} />
    </Routes>
  );
};

export default Content;
